import React from "react";
import products from "../../resources/data/products";
import { useEffect } from "react";
import './Recommendations.css';

function Recommendations() {
  const [selectedProductId, setSelectedProductId] = React.useState(null);

  function handleClick(product) {
    setSelectedProductId(product.id);
  }

  return (
    <div className="products">
      <h2>Product Recommendations</h2>
      <ul className="product-cards-box">
        {setDelaySoFar(200)}
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            handleClick={handleClick}
            selectedProductId={selectedProductId}
          />
        ))}
      </ul>
      <p className="disclaimer">
        As an Amazon Associate I earn from qualifying purchases.
      </p>
      {selectedProductId && <SelectedProduct product={products.find(p => p.id === selectedProductId)} setSelectedProductId={setSelectedProductId} />}
    </div>
  );
}

function SelectedProduct({ product, setSelectedProductId }) {
  return (
    <div className="selected-product">
      <div className="popout-box">
        <button className="close-button" onClick={() => setSelectedProductId(null)}>
          <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" stroke-width="0" />
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
            <g id="SVGRepo_iconCarrier"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000" /></g>
          </svg>
        </button>
        <div className="product-popout-container">
          <div className="product-info">
            <h3 className="product-name">{product.name}</h3>
            <p className="product-notes">{product.notes}</p>
            <div className="buttons-box">
              <LinkButton product={product} />
              <ShareButton product={product} />
            </div>
          </div>
          <div className="product-image-box">
            <img
              className={"product-image"}
              src={product.photo}
              alt={product.name}
              onError={(e) => { e.target.style.display = 'none' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function ProductCard({ product, handleClick, selectedProductId }) {
  const [data, setData] = React.useState(null);
  let isSelected = product.id === selectedProductId;
  let isNew = product.categories && product.categories.includes("new");

  useEffect(() => {
    let mounted = true;
    getProductData(product.id).then((res) => {
      if (mounted) {
        setData(res);
      }
    });
    return () => {
      mounted = false;
    }
  }, [product.id]);

  return (
    <li className={`product-card ${isSelected ? "opened" : ""}`} onClick={() => handleClick(product)}>
      {isNew && <span className="new-badge">NEW!</span>}
      <h3 className="product-name">{data ? data.name : <div className="product-name fallback"></div>}</h3>
      <p className="product-notes">{data ? data.notes : <><div className="product-notes fallback item1"></div><div className="product-notes fallback item2"></div></>}</p>
      {
        data ? (
          <img
            className={"product-image"}
            src={data.photo}
            alt={data.name}
            onError={(e) => { e.target.style.display = 'none' }}
          />
        ) : (
          <div className="product-image fallback"></div>
        )
      }
    </li>
  );
}

function LinkButton({ product }) {
  if (!product.link) {
    return null;
  }
  switch (product.site) {
    case "IMAGE":
      return (
        <button className="buy-button" onClick={() => window.open(makeImageAffiliateLink(product.link, "site"), "_blank")}>
          View on Image
        </button>
      );
    case "AMAZON":
      return (
        <button className="buy-button" onClick={() => window.open(product.link, "_blank")}>
          View on Amazon
        </button>
      );
    default:
      return (
        <button className="buy-button" onClick={() => window.open(product.link, "_blank")}>
          View Product
        </button>
      );
  }
}

function ShareButton({ product }) {
  switch (product.site) {
    case "IMAGE":
      return (
        <button className="share-button" onClick={() => shareProduct({ ...product, link: makeImageAffiliateLink(product.link, "share") })}>
          Share Link
        </button>
      );
    default:
      return (
        <button className="share-button" onClick={() => shareProduct(product)}>
          Share Link
        </button>
      );
  }
}

function makeImageAffiliateLink(link, ref) {
  const awinmid = "34655";
  const awinaffid = "2875711";
  const url = new URL("https://www.awin1.com/cread.php");
  url.searchParams.set("awinmid", awinmid);
  url.searchParams.set("awinaffid", awinaffid);
  url.searchParams.set("clickref", ref);
  // url.searchParams.set("clickref2", ref2);
  url.searchParams.set("ued", link);
  return url.toString();
}

let delaySoFar = 0;
function getProductData(productId) {
  const product = products.find(p => p.id === productId);
  const delay = Math.random() * 200;
  setDelaySoFar(delaySoFar + delay);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(product);
    }, delaySoFar);
  });
}

function setDelaySoFar(value) {
  delaySoFar = value;
}

const isDesktop = window.matchMedia(
  "(hover: hover) and (pointer: fine)"
).matches;

function shareProduct(product) {
  if (navigator.share && !isDesktop) {
    navigator.share({
      title: product.name,
      text: `${product.name}, a recommendation from jannineskincare.com`,
      url: product.link
    }).then(() => {
      console.log('Product shared.');
    })
      .catch(console.error);
  } else {
    navigator.clipboard.writeText(product.link)
      .then(() => {
        alert('Product link copied to clipboard!');
      })
      .catch((err) => {
        console.error('Could not copy text: ', err);
        alert('Failed to copy product link. Please try again.');
      });
  }
}

export default Recommendations;